import React from 'react';
import { LaunchDarklyFeatureFlags } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { useDarkly } from './useDarkly';

interface Payload<V> {
  value: V;
}

interface DarklyFeatureProps<KEY extends keyof LaunchDarklyFeatureFlags> {
  flag: KEY;
  hideIfFalsy?: boolean;
  children: (payload: Payload<LaunchDarklyFeatureFlags[KEY]>) => React.ReactNode;
}

export function DarklyFeature<KEY extends keyof LaunchDarklyFeatureFlags>({
  flag,
  children,
  hideIfFalsy = true
}: DarklyFeatureProps<KEY>) {
  const flags = useDarkly();
  const value = flags[flag];
  if (hideIfFalsy && !isTruthy(flags[flag])) {
    return null;
  }
  return children({ value });
}

function isTruthy(value: boolean | string | number | undefined | null): boolean {
  return typeof value === 'number' || !!value;
}
